module.exports = __webpack_public_path__ + "img/Zugtrupp_FZ-Logistik.ea60c40c.svg";